import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'

const {
  REQUEST_DETAILS,
  RECEIVE_DETAILS,
  REQUEST_REGISTRATON,
  RECEIVE_REGISTRATON
} = actionTypes

export function fetchConferenceDetails (id) {
  return function (dispatch) {
    dispatch({type: REQUEST_DETAILS})
    return fetch(`${config.URI}/api/v1/show_only_conf/${id}`)
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({
            type: RECEIVE_DETAILS,
            conferenceDetails: res.data.conferences
          })
        } else {
          dispatch({type: RECEIVE_DETAILS, conferenceDetails: {}})
          console.error(res.errors)
        }
      })
      .catch(e => {
        console.error(e)
        isSentry(e)
      })
  }
}

export function registerEmail (email, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_REGISTRATON})
    const payload = {
      email
    }
    return fetch(`${config.URI}/api/v1/participants/create_register/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        dispatch({
          type: RECEIVE_REGISTRATON
        })
        return res
      })
      .catch(e => {
        console.error(e)
        isSentry(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/Registration/actions/index.js